// extracted by mini-css-extract-plugin
export default {"icon":"CloseIcon_icon__IyIfi","icon__close":"CloseIcon_icon__close__SpQZ2","icon__large":"CloseIcon_icon__large__ZwOW7"};